angular.module('impactx.osu').controller('OsuLoginCtrl', [
    '$scope',
    '$securityManager',
    'dataGen',
    '$routeParams',
    '$redirect',
    '$mdDialog',
    'LoginService',
    OsuLoginCtrl]);

function OsuLoginCtrl($scope, $securityManager, dataGen, $routeParams, $redirect, $mdDialog, LoginService) {
    var token = $routeParams.token;
    if (token) {
        $securityManager.setToken(token);
        LoginService.refreshUI(false);
    }

    if ($securityManager.isAuthorized()) {
        dataGen.getData({}, {osutan: $routeParams.tan}, "/osu/loggedinredirect").then(function (data) {
            if (data.data.osuredirect && !data.data.errorMessage) {
                $redirect.redirectTo(null, data.data.osuredirect);
            }
            else {
                $scope.errorMessage = data.data.errorMessage;
                $scope.osuredirect = data.data.osuredirect;
            }
        });
    }
    else {
        $mdDialog.show({
            templateUrl: './modules/osu/templates/osulogin.html',
            controller: "OsuLoginDialogCtrl",
            controllerAs: "osuLoginDialogCtrl",
            locals: {
                osutan: $routeParams.tan
            },
            clickOutsideToClose: false,
            escapeToClose: false,
            fullscreen: false
        }).then(function (errorObject) {
            if (errorObject.errorMessage) {
                $scope.errorMessage = errorObject.errorMessage;
                $scope.osuredirect = errorObject.osuredirect;
            }
        });
    }
}